import z from 'zod';
import {base64ObjectSchema} from '../_other/base64ObjectSchema';

export const tradeExtensionMessageRequestSchema = z.object({
  note: z.string().optional(),
  screenshot: base64ObjectSchema
    .extend({
      data: z.string().min(1),
      type: z.enum(['image/jpeg', 'image/png']),
    })
    .optional(),
});

export interface TradeExtensionMessageRequest extends z.infer<typeof tradeExtensionMessageRequestSchema> {}
